import { generateActions } from "../utils";

export const POST_REVIEW = generateActions("POST_REVIEW");
export const UPDATE_REVIEW = generateActions("UPDATE_REVIEW");
export const DELETE_REVIEW = generateActions("DELETE_REVIEW");
export const GET_COMPANY_REVIEWS = generateActions("GET_COMPANY_REVIEWS");
export const GET_USER_REVIEWS = generateActions("GET_USER_REVIEWS");
export const GET_REVIEWS = generateActions("GET_REVIEWS");
export const GET_REVIEW = generateActions("GET_REVIEW");
